import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import type { ThemePref } from '../../lib/theme';

const TITLES: Record<ThemePref, string> = {
  system: 'Theme: System (click for Dark)',
  dark: 'Theme: Dark (click for Light)',
  light: 'Theme: Light (click for System)',
};

export function ThemeToggle() {
  const { theme, cycleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={cycleTheme}
      title={TITLES[theme]}
      aria-label={TITLES[theme]}
      className="flex items-center justify-center rounded transition-colors"
      style={{
        width: '30px',
        height: '30px',
        color: 'var(--text-tertiary)',
        backgroundColor: 'transparent',
        border: '1px solid var(--border)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--bg-hover)';
        e.currentTarget.style.color = 'var(--text-secondary)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
        e.currentTarget.style.color = 'var(--text-tertiary)';
      }}
    >
      <ThemeIcon theme={theme} />
    </button>
  );
}

function ThemeIcon({ theme }: { theme: ThemePref }) {
  const common = {
    width: 14,
    height: 14,
    viewBox: '0 0 16 16',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  };

  if (theme === 'light') {
    return (
      <svg {...common}>
        <circle cx="8" cy="8" r="3" />
        <path d="M8 1.5v1.7 M8 12.8v1.7 M1.5 8h1.7 M12.8 8h1.7 M3.2 3.2l1.2 1.2 M11.6 11.6l1.2 1.2 M12.8 3.2l-1.2 1.2 M4.4 11.6l-1.2 1.2" />
      </svg>
    );
  }
  if (theme === 'dark') {
    return (
      <svg {...common}>
        <path d="M13.5 10a5.5 5.5 0 0 1-7.5-7.5A6 6 0 1 0 13.5 10z" />
      </svg>
    );
  }
  // system
  return (
    <svg {...common}>
      <rect x="1.5" y="2.5" width="13" height="9" rx="1" />
      <path d="M1.5 9h13 M5 14h6 M8 11.5V14" />
    </svg>
  );
}
